import { render, staticRenderFns } from "./FormMessage.vue?vue&type=template&id=a68e40d4&scoped=true&"
import script from "./FormMessage.vue?vue&type=script&lang=js&"
export * from "./FormMessage.vue?vue&type=script&lang=js&"
import style0 from "./FormMessage.vue?vue&type=style&index=0&id=a68e40d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e40d4",
  null
  
)

export default component.exports